import React, { useContext } from 'react';
import { Plural, Trans, t } from '@lingui/macro';
import { connect } from 'react-redux';
import { FileOutlined } from '@ant-design/icons';
import { Button, Row, Col } from 'antd';
import fileSize from 'filesize';
import { FileContext } from '../Provider';
import { UsageType } from '../../../containers/AppPage/ControlPanel/Subscription/QuotaSubscription/UsageType';

function SubmitFilesButton() {
    const fileContext = useContext(FileContext);
    const { contextState, contextAction, contextProps } = fileContext;
    const { rowList, rowIdList } = contextState;
    const { resetModal } = contextAction;
    const { onOk, initFiles } = contextProps;

    // click submit in multiple mode
    const submitFiles = () => {
        // preprocess files ('add'/'remove') based on selection and deselection in filemanager and
        // compare with transactionFiles / ContactFiles
        const initFileIds = initFiles.map(f => f.id);

        // // in initFiles, but not in rowList ==> deleted
        // const removeFiles = initFiles.filter(file => !rowList.map(f => f.id).includes(file.id))
        // difference (initFiles - selectedFiles)
        // in rowList, not in initFiles ==> addFile
        // difference (selectedFiles - initFiles)
        const addFiles = rowList.filter(selected => !initFileIds.includes(selected.id));

        onOk({
            add: addFiles,
            // remove: removeFiles
        });
        resetModal();
    };

    return (
        <Button type="primary" onClick={submitFiles} disabled={!rowIdList.length}>
            <FileOutlined />
            &nbsp;
            <Plural value={rowIdList.length} one="Select # File" other="Select # Files" />
        </Button>
    );
}

export const ModalFooter = connect(state => ({
    quotas: state.Quota.quotas,
}), {})(
    props => {
        const fileContext = useContext(FileContext);
        const { contextState, contextAction, contextProps } = fileContext;
        const { rowList, rowIdList } = contextState;
        const { resetModal } = contextAction;
        const { mode } = contextProps;
        const { quotas } = props;

        const storageQuota = quotas?.find(q => q.type === UsageType.STORAGE);
        const remainingStorage = (storageQuota?.allocation_total || 0) - (storageQuota?.utilisation || 0);

        return (mode === 'multiple' ?
            <Row display="flex" justify="space-between">
                {/* <Col className="div__delete-button"></Col> */}
                <Col className="div__usage-limit">
                    { t`${remainingStorage ? fileSize(remainingStorage) : '-'} Available`}
                </Col>
                <Col className="div__submit-cancel-buttons">
                    <Button className="btn--cancel" onClick={resetModal}>
                        <Trans>Cancel</Trans>
                    </Button>
                    <SubmitFilesButton
                        className="btn--submit"
                        rowIdList={rowIdList}
                        rowList={rowList}
                        resetModal={resetModal}
                    />
                </Col>
            </Row>
            : null
        );
    },
);
